import adminApi from "./adminApi";

export const fetchDashboardData = async () => {
  const res = await adminApi.get("/admin/dashboard");
  return res.data;
};
